<h2 class="proj-title">{{currentProject.title}}</h2>

<div>
    <button (click)="goBack()" type="button" class="btn btn-primary">
        <i class="fas fa-arrow-left"></i>Back
    </button>
</div>

<div class="image-wrapper">
    <img class="proj-imgs" [src]="currentProject.cover_image">
</div>
    


<h3 class="text-xs-center text-md-left">Project Description</h3>
<div>{{currentProject.abstract}}</div>

<h3 class="text-xs-center text-md-left">Project Publications</h3>
<app-pub-wrapper [pub_group]=getPubsbyProjectId()></app-pub-wrapper>